const matchhoroscope = {

    // Header Section
    "kundli_matching_service": "Kundli Matching Service",
    "match_your": "Match Your",
    "horoscopes": "Kundli",
    "for_perfect_union": "For Perfect Union",
    "match_horoscope_description": "Discover your compatibility through authentic Vedic astrology. Our comprehensive Kundli matching analyzes 36 Gunas to determine marital harmony and relationship success.",

    // Form Fields
    "partner_1_details": "Partner 1 Details",
    "partner_2_details": "Partner 2 Details",
    "male_groom": "Male/Groom",
    "female_bride": "Female/Bride",
    "enter_groom_name": "Enter groom's full name",
    "enter_bride_name": "Enter bride's full name",
    "full_name": "Full Name",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "date_time_of_birth": "Date & Time of Birth",
    "place_of_birth": "Place of Birth",
    "enter_partner_name": "Enter partner name",
    "city_state_country": "City, State, Country",
    "email_address": "Email Address",
    "phone_number": "Phone Number",
    "enter_email_for_report": "Enter your email for detailed report",
    "enter_phone": "Enter your phone",
    "contact_details_info": "Providing contact details ensures you receive the detailed compatibility report directly.",
    "service_pricing": "Service Pricing",
    "complete_horoscope_matching": "Complete Horoscope Matching Analysis",
    "one_time_payment_info": "One-time payment for complete horoscope matching analysis by expert astrologers",
    "detailed_compatibility_analysis": "Detailed Compatibility Analysis",
    "guna_milan_36_points": "Guna Milan (36 Points System)",
    "manglik_dosha_analysis": "Manglik Dosha Analysis",
    "future_predictions_couple": "Future Predictions for Couple",
    "remedial_solutions": "Remedial Solutions & Suggestions",
    "pdf_report_download": "PDF Report Download",
    "contact_information": "Contact Information",

    // Actions
    "match_horoscopes_now": "Match Kundlis Now",
    "matching_horoscopes": "Matching Kundli",
    "pay_and_match": "Pay & Match Horoscopes",
    "processing_payment": "Processing Payment...",
    "dd_mm_yyyy_time_format": "Enter DD/MM/YYYY and HH:MM (12-hour) with AM/PM",
    "am": "AM",
    "pm": "PM",
    "dd_placeholder": "DD",
    "mm_placeholder": "MM", 
    "yyyy_placeholder": "YYYY",
    "hh_placeholder": "HH",

    // Results
    "compatibility_result": "Compatibility Result",
    "overall_compatibility": "Overall Compatibility",
    "guna_milan_points": "Guna Milan Points",
    "match_status": "Match Status",
    "excellent_match": "Excellent Match",
    "good_match": "Good Match",
    "average_match": "Average Match",
    "detailed_guna_analysis": "Detailed Guna Analysis",

    // Actions
    "download_detailed_report": "Download Detailed Report",
    "consult_astrologer": "Consult Astrologer",
    "match_another_couple": "Match Another Couple",

    // Features
    "what_our_matching_includes": "What Our Matching Includes",
    "36_guna_analysis": "36 Guna Analysis",
    "36_guna_analysis_desc": "Complete assessment of all 36 compatibility points",
    "love_compatibility": "Your Love Life",
    "love_compatibility_desc": "Emotional and romantic harmony analysis",
    "family_harmony": "Family Harmony",
    "family_harmony_desc": "Long-term relationship stability prediction",
    "manglik_dosha": "Manglik Dosha Check",
    "manglik_dosha_desc": "Identification and remedial solutions for doshas",

    // Thank You Message
    "thank_you_submission": "Thank You for Your Submission!",
    "data_received_message": "We have successfully received your horoscope matching request. Our experienced astrologers will carefully analyze both charts.",

    // Security & Timeline
    "your_data_secure": "Your Data is 100% Secure",
    "data_security_message": "All personal information is encrypted and protected. We never share your details with third parties.",
    "response_within_12_hours": "Response Within 12 Hours",
    "response_time_message": "Our expert astrologers will prepare your detailed compatibility report and contact you soon.",

    // Support
    "need_immediate_help": "Need Immediate Assistance?",
    "whatsapp_support": "WhatsApp Support",
    "processing_request": "Processing Your Request",
    "back_to_home": "Back to Home"

};

export default matchhoroscope;